import Loadable from "../../../components/Loadable";

const Peminatan = Loadable(() => import("./Peminatan"));

export default {
  Peminatan,
};
